// export const getBreadcrumbSelector = (routeItems = [], parentPath = '') =>
//   routeItems.reduce(
//     (acc, curr) =>
//       curr.path === parentPath
//         ? [...getBreadcrumbSelector(routeItems, curr.parentPath), curr, ...acc]
//         : acc,
//     []
//   );

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(find, 'g'), replace)
}

// eslint-disable-next-line import/prefer-default-export
export const simplifyPhoneNumber = (phoneNumber) => {
    const phoneNumberExcludingHyphen = replaceAll(phoneNumber, '-', '')
    const phoneNumberExcludingSpace = replaceAll(phoneNumberExcludingHyphen, ' ', '')
    const phoneNumberExcludingStartBracket = replaceAll(phoneNumberExcludingSpace, '\\(', '')
    const phoneNumberExcludingEndBracket = replaceAll(phoneNumberExcludingStartBracket, '\\)', '')
    return phoneNumberExcludingEndBracket
}